import { render, staticRenderFns } from "./shouru_tongji.vue?vue&type=template&id=3adb3298&scoped=true"
import script from "./shouru_tongji.vue?vue&type=script&lang=js"
export * from "./shouru_tongji.vue?vue&type=script&lang=js"
import style0 from "./shouru_tongji.vue?vue&type=style&index=0&id=3adb3298&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adb3298",
  null
  
)

export default component.exports